export default "__VITE_ASSET__BcmD_XsD__"